<template>
    <div>
        <v-container pt-0>
            <v-layout column>
                <template v-for="round in playoffs">
                    <div class="mb-5">
                        <v-layout row align-baseline fill-height>
                            <v-flex>
                                <div class="title">{{ round.round_title }}</div>
                            </v-flex>
                            <v-flex v-if="is_admin()" class="text-xs-right">
                                <v-btn
                                    flat
                                    small
                                    color="primary"
                                    class="mb-3 mt-3"
                                    v-bind:to="{name: 'admin_playoffs_matchup_new', params: { round }}"
                                    exact
                                >New Matchup</v-btn>
                                <v-btn
                                    flat
                                    small
                                    color="error"
                                    v-on:click="deleteRound(round)"
                                >Delete Round</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <template v-for="matchup in matchupsInRound(round.id)">
                            <v-layout column mb-3>
                                <v-flex xs12>
                                    <v-card height="100%">
                                        <v-card-title primary-title>
                                            <v-layout column>
                                                <div>
                                                    <div class="subheading">
                                                        <team-badge
                                                            v-bind:team="getTeam(matchup.home_team_id).team"
                                                            v-bind:colour="getTeam(matchup.home_team_id).colour"
                                                            v-bind:full_width="false"
                                                        ></team-badge>&nbsp;vs.
                                                        <team-badge
                                                            v-bind:team="getTeam(matchup.away_team_id).team"
                                                            v-bind:colour="getTeam(matchup.away_team_id).colour"
                                                            v-bind:full_width="false"
                                                        ></team-badge>
                                                    </div>
                                                    <span
                                                        class="grey--text text--darken-3"
                                                    >{{getSeries(matchup)}}</span>
                                                </div>
                                                <v-divider class="mb-3"></v-divider>

                                                <v-container grid-list-md>
                                                    <v-layout row wrap justify-start>
                                                        <template
                                                            v-for="match in matchesInMatchup(round.id, matchup.id)"
                                                            class="mb-3"
                                                        >
                                                            <v-flex xs12 md6 lg4>
                                                                <v-card class="mb-2">
                                                                    <v-card-title>
                                                                        <div
                                                                            class="body-1 font-weight-bold"
                                                                        >{{ matchTitle(match) }}</div>
                                                                        <v-spacer></v-spacer>
                                                                        <div
                                                                            class="body-1 font-weight-bold"
                                                                        >{{matchDate(match.match_moment)}}</div>
                                                                    </v-card-title>
                                                                    <v-divider></v-divider>
                                                                    <v-list dense>
                                                                        <v-list-tile>
                                                                            <v-list-tile-content>
                                                                                <team-badge
                                                                                    v-bind:team="getTeam(match.away_team_id).team"
                                                                                    v-bind:colour="getTeam(match.away_team_id).colour"
                                                                                    width="120px"
                                                                                ></team-badge>
                                                                            </v-list-tile-content>
                                                                            <v-list-tile-content
                                                                                class="align-end font-weight-bold"
                                                                            >{{ match.game_played ? match.away_team_score : 'TBD' }}</v-list-tile-content>
                                                                        </v-list-tile>
                                                                        <v-list-tile>
                                                                            <v-list-tile-content>
                                                                                <team-badge
                                                                                    v-bind:team="getTeam(match.home_team_id).team"
                                                                                    v-bind:colour="getTeam(match.home_team_id).colour"
                                                                                    width="120px"
                                                                                ></team-badge>
                                                                            </v-list-tile-content>
                                                                            <v-list-tile-content
                                                                                class="align-end font-weight-bold"
                                                                            >{{ match.game_played ? match.home_team_score : 'TBD' }}</v-list-tile-content>
                                                                        </v-list-tile>
                                                                    </v-list>
                                                                    <v-divider></v-divider>
                                                                    <v-card-actions
                                                                        v-if="is_admin()"
                                                                    >
                                                                        <v-btn
                                                                            flat
                                                                            small
                                                                            color="warning"
                                                                            v-bind:to="{name: 'admin_playoffs_match_edit', params: {match}}"
                                                                        >Edit</v-btn>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-flex>
                                                        </template>
                                                    </v-layout>
                                                </v-container>
                                            </v-layout>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-actions v-if="is_admin()">
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        flat
                                                        small
                                                        color="error"
                                                        v-on="on"
                                                    >Delete Matchup</v-btn>
                                                </template>
                                                <v-list>
                                                    <v-btn
                                                        flat
                                                        small
                                                        color="error"
                                                        v-on:click="deleteMatchup(matchup)"
                                                    >Really Delete?</v-btn>
                                                </v-list>
                                            </v-menu>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </template>
                    </div>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'PlayoffsGrid',
    props: ['admin'],
    data() {
        return {
            exact: true
        }
    },
    methods: {
        is_admin() {
            if (this.admin) {
                return true
            } else {
                return false
            }
        },
        deleteRound(round) {
            this.$store.dispatch('deletePlayoffRound', round)
        },
        deleteMatchup(matchup) {
            this.$store.dispatch('deletePlayoffMatchup', matchup)
        },
        deleteMatch(match) {
            this.$store.dispatch('deletePlayoffMatch', match)
        },
        matchupsInRound(round_id) {
            return this.$store.getters.getPlayoffMatchupsInRound(round_id)
        },
        matchesInMatchup(round_id, matchup_id) {
            return this.$store.getters.getPlayoffMatchesInMatchup(round_id, matchup_id)
        },
        getTeam(team_id) {
            let team = this.$store.getters.getTeamById(team_id)
            if (team) {
                return team
            }
        },
        getSeries(matchup) {
            let winsObject = this.$store.getters.getPlayoffMatchupWins(matchup)
            let awayTeam = winsObject.awayTeam
            let awayTeamWins = winsObject.awayTeamWins
            let homeTeam = winsObject.homeTeam
            let homeTeamWins = winsObject.homeTeamWins

            if (awayTeamWins === homeTeamWins) {
                return `Tied ${awayTeamWins}-${homeTeamWins}`
            } else if (awayTeamWins < homeTeamWins) {
                let state = 'leads'
                if (homeTeamWins > winsObject.bestOf / 2) {
                    state = 'wins'
                }
                return `${homeTeam.team} ${state} ${homeTeamWins}-${awayTeamWins}`
            } else {
                let state = 'leads'
                if (awayTeamWins > winsObject.bestOf / 2) {
                    state = 'wins'
                }
                return `${awayTeam.team} ${state} ${awayTeamWins}-${homeTeamWins}`
            }
        },
        matchTitle(match) {
            let matchTitle = match.match_title

            let matchup = this.$store.getters.getPlayoffMatchupById(match.matchup_id)
            let winsObject = this.$store.getters.getPlayoffMatchupWins(matchup)
            let awayTeamWins = winsObject.awayTeamWins
            let homeTeamWins = winsObject.homeTeamWins

            if (match.match <= Math.round(winsObject.bestOf / 2)) {
                return matchTitle
            } else {
                if (
                    awayTeamWins >= match.match - Math.round(winsObject.bestOf / 2) &&
                    homeTeamWins >= match.match - Math.round(winsObject.bestOf / 2)
                ) {
                    return matchTitle
                } else {
                    return `${matchTitle} (if needed)`
                }
            }
        },
        matchDate(matchMoment) {
            if (!matchMoment) {
                return null
            }

            return `${matchMoment.format('MMM D')} @ ${matchMoment.format('h:mm a')}`
        }
    },
    computed: {
        playoffs() {
            return this.$store.getters.getSortedPlayoffRounds
        }
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
